// extracted by mini-css-extract-plugin
export default {"Prefinal":"Prefinal_Prefinal__2Hv+4","dontWantBtn":"Prefinal_dontWantBtn__OJJ79","Pref1":"Prefinal_Pref1__3UJ6S","Pref2":"Prefinal_Pref2__ZlWlJ"};